import { AppHistory } from "@faire/help-center-utils/AppHistory";
import { initializeHotjar } from "@faire/help-center/initialize/hotjar";
import { setupHotLoading } from "@faire/web--source/common/hotReloading";
import { HistoryTiming } from "@faire/web--source/common/performance/HistoryTiming";
import { ResourceTimingCollector } from "@faire/web--source/common/performance/ResourceTimingCollector";
import { initializePolyfill } from "@faire/web--source/common/polyfill";
import { reloadExpiredSessions } from "@faire/web--source/common/releaseReloader";
import once from "lodash/once";

export default once(async () => {
  await initializePolyfill();

  reloadExpiredSessions();
  setupHotLoading("8767");

  initializeHotjar();

  ResourceTimingCollector.get().initialize();
  HistoryTiming.get().initialize(AppHistory.get().history);
});
